import { render, staticRenderFns } from "./RequestDetailHeader.vue?vue&type=template&id=4e85533b"
import script from "./RequestDetailHeader.vue?vue&type=script&lang=js"
export * from "./RequestDetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports